module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "onepager-container"
  }, [_vm._l((_vm.onepagers), function(onepager) {
    return _c('onepager', {
      key: onepager.type,
      attrs: {
        "environment": _vm.environment,
        "logo": _vm.logo,
        "multiRowPath": onepager.multiRowPath,
        "products": onepager.products,
        "tableConfig": onepager.tableConfig,
        "template": _vm.getTemplateManager(onepager.template),
        "type": onepager.type
      }
    })
  }), _vm._v(" "), (_vm.lastPage[_vm.appInstance]) ? _c('document-container', {
    staticClass: "last-page",
    attrs: {
      "document-type": "onepager",
      "logo": _vm.logo
    }
  }, [_c('div', {
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('Textblock', {
    attrs: {
      "data": _vm.lastPage[_vm.appInstance]
    }
  })], 1)]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3530e18c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/onepager/OnepagerContainer.vue
// module id = 673
// module chunks = 0